import { Component, EventEmitter, Injectable, Input, Output, inject, signal } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { Location } from '@angular/common';
@Injectable({
  providedIn: 'root'
})
@Component({
  selector: 'app-alert',
  imports: [],
  templateUrl: './alert.component.html',
  styleUrl: './alert.component.css'
})
export class AlertComponent {
  message!: string
  type: string = 'success | error';
  currentRoute : string = '' ;
  constructor ( private router: Router , private location: Location) {
    this.currentRoute = this.router.url
   }
  @Input() goBack:boolean = true;
  @Output() onClose = new EventEmitter<void>();
  @Input() emitEventOnClose: boolean = false;
  @Input() returnFocus:boolean = true;
  openAlert = (type: string, message: string) => {

    let icon: SweetAlertIcon = "success";
    let title = message;
    switch (type) {
      case "error":
        icon = "error";
        break;
    }
    Swal.fire({
      title: title,
      theme: 'material-ui',
      icon: icon,
      draggable: true,
      returnFocus: this.returnFocus,
      confirmButtonText: 'Cerrar'
    }).then((result) => {
      if (result.isConfirmed && this.goBack) {
        this.location.back();
      }
      if(this.emitEventOnClose) {
        this.onClose.emit();
      }
    });
  }
}
